/**
 * GA4 CTA 計測用のユーティリティ。
 *
 * public/index.html のインラインスクリプトが click をイベント委譲で拾い、
 * data-gtag-event を持つ最も近い祖先要素の属性を GA4 イベントとして送信する。
 * リンクテキストや URL はパラメータに入れない
 * （個人情報の混入とカーディナリティ肥大を避けるため）。
 */

/** 主要導線に付与する data 属性をまとめて生成する */
export const ctaAttrs = (ctaType, ctaLocation) => ({
  'data-gtag-event': 'cta_click',
  'data-cta-type': ctaType,
  'data-cta-location': ctaLocation,
});

/** 表示用の電話番号文字列を tel: リンク用に正規化する */
export const telHref = (phone) =>
  'tel:' + String(phone).replace(/[^0-9+]/g, '');
